// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Search_wrapper__3b_jE","searchFrom":"Search_searchFrom__25SEO","searchIcon":"Search_searchIcon__1pNLm","clearIcon":"Search_clearIcon__ttnq-"};